export const CommodityOrder = [
    "Corn",
    "Soybeans",
    "Wheat",
    "Sorghum",
    "Seed Cotton",
    "Rice",
    "Peanuts",
    "Milk",
    "Beef",
    "Pork",
    "Chicken"
];
